
import Vue from 'vue'

/* eslint-disable camelcase */
interface IActiveSession {
  session_id: string
  device: string
  ip: string | null
  created_at: string
  last_seen_at: string
  is_current: boolean
  remember: boolean
}

interface IEndedSession {
  session_id: string
  device: string
  ip: string | null
  created_at: string
  last_seen_at: string
  ended_at: string | null
  status: string
  remember: boolean
}
/* eslint-enable camelcase */

const STATUS_LABELS: Record<string, string> = {
  logout: 'Вы вышли',
  revoked: 'Завершена с другого устройства',
  expired: 'Истекла'
}

export default Vue.extend({
  name: 'DevicesSessions',
  data () {
    return {
      loading: false,
      errors: [] as string[],
      activeItems: [] as IActiveSession[],
      terminatingId: '' as string,

      panel: undefined as number | undefined,
      historyLoaded: false,
      historyLoading: false,
      historyLoadingMore: false,
      historyPage: 1,
      historyHasNext: false,
      endedItems: [] as IEndedSession[]
    }
  },
  mounted () {
    this.fetchActive()
  },
  methods: {
    async fetchActive (): Promise<void> {
      this.loading = true
      this.errors = []
      const response = await this.$services.sessions.list()
      this.loading = false
      if (response.success) {
        this.activeItems = response.data
      } else {
        this.errors = ['Не удалось загрузить активные сессии. Попробуйте позже.']
      }
    },
    onExpandChange (value: number | undefined): void {
      if (value === 0 && !this.historyLoaded) {
        this.fetchHistory(1)
      }
    },
    async fetchHistory (page: number): Promise<void> {
      const isFirst = page === 1
      isFirst ? (this.historyLoading = true) : (this.historyLoadingMore = true)
      const response = await this.$services.sessions.history(page, true)
      this.historyLoading = false
      this.historyLoadingMore = false
      if (!response.success) {
        this.errors = ['Не удалось загрузить историю сессий. Попробуйте позже.']
        return
      }
      this.historyLoaded = true
      this.historyPage = page
      this.historyHasNext = Boolean(response.data.next)
      this.endedItems = isFirst ? response.data.results : [...this.endedItems, ...response.data.results]
    },
    loadMoreHistory (): void {
      this.fetchHistory(this.historyPage + 1)
    },
    deviceLabel (s: { device: string }): string {
      return s.device || 'Неизвестное устройство'
    },
    statusLabel (status: string): string {
      return STATUS_LABELS[status] || 'Завершена'
    },
    formatDate (value: string): string {
      if (!value) return '—'
      const date = new Date(value)
      if (isNaN(date.getTime())) return '—'
      const formatted = date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC'
      })
      return `${formatted} UTC`
    },
    askTerminate (s: IActiveSession): void {
      const self = this as any
      self.$store.dispatch('popupModule/openPopup', {
        type: 'confirmPopup',
        letDefaultClose: true,
        title: 'Завершить сессию?',
        content: `Сессия «${this.deviceLabel(s)}» будет завершена.`,
        actions: [
          {
            title: 'Завершить',
            isAccent: true,
            callback: () => {
              self.$store.commit('popupModule/setClosed')
              self.terminate(s)
            }
          },
          {
            title: 'Отмена',
            isAccent: false,
            callback: () => self.$store.commit('popupModule/setClosed')
          }
        ]
      })
    },
    async terminate (s: IActiveSession): Promise<void> {
      this.terminatingId = s.session_id
      this.errors = []
      const response = await this.$services.sessions.terminate(s.session_id)
      this.terminatingId = ''
      if (!response.success) {
        this.errors = ['Не удалось завершить сессию. Попробуйте позже.']
        return
      }
      this.activeItems = this.activeItems.filter((x: IActiveSession) => x.session_id !== s.session_id)
      this.historyLoaded = false
      this.endedItems = []
      if (this.panel === 0) this.fetchHistory(1)
    }
  }
})
